import { api } from "../services/api";

document.addEventListener("DOMContentLoaded", () => {
    const yearSelect = document.getElementById("year");
    const monthSelect = document.getElementById("month");
    const resultsContainer = document.getElementById("transparencies__results");

    const urlParams = new URLSearchParams(window.location.search);
    const yearSlug = urlParams.get('ano');
    const monthSlug = urlParams.get('mes');

    if (yearSlug && monthSlug) {
        if (!isNaN(yearSlug)) {
            yearSelect.value = yearSlug;
            monthSelect.value = monthSlug;
            fetchTransparencies();
        } else {
            console.error("O slug do ano não é um número válido.");
        }
    }

    async function fetchTransparencies() {
        const yearSlug = yearSelect.value;
        const monthSlug = monthSelect.value;

        if (!yearSlug || !monthSlug) {
            resultsContainer.innerHTML = "<p class='transparencies__message'>Por favor, selecione um ano e um mês válidos.</p>";
            return;
        }

        updateURL(yearSlug, monthSlug);

        try {
            const response = await api.get(`/transparencies?ano=${yearSlug}&mes=${monthSlug}`);
            if (response.status !== 200) {
                throw new Error("Erro na requisição");
            }
            const transparencies = response.data;

            if (transparencies.length > 0) {
                renderTransparencies(transparencies, resultsContainer);
            } else {
                resultsContainer.innerHTML = `<p class="transparencies__message">Não existe prestação de contas para esse mês e ano</p>`;
            }
        } catch (error) {
            console.error("Erro ao buscar as transparências:", error);
            resultsContainer.innerHTML = `<p class="transparencies__message">Ocorreu um erro ao carregar os dados: ${error.message}</p>`;
        }
    }

    function renderTransparencies(transparencies, container) {
        container.innerHTML = "";
        transparencies.forEach(transparency => {
            const titleElement = document.createElement("h3");
            titleElement.className = "transparencies__results__title";
            titleElement.textContent = transparency.title;
            container.appendChild(titleElement);

            if (transparency.archives.length > 0) {
                const listElement = document.createElement("ul");
                listElement.className = "transparencies__results__list";
                transparency.archives.forEach((file, index) => {
                    const listItem = createFileLink(file, index);
                    listElement.appendChild(listItem);
                });
                container.appendChild(listElement);
            } else {
                const noFilesElement = document.createElement("p");
                noFilesElement.textContent = "Sem arquivos disponíveis.";
                container.appendChild(noFilesElement);
            }
        });
    }

    function createFileLink(file, index) {
        const listItem = document.createElement("li");
        const linkElement = document.createElement("a");
        linkElement.href = `${process.env.MIX_APP_URL}/storage/${file.path}`;
        linkElement.download = file.name;
        linkElement.target = "_blank";
        linkElement.className = "transparencies__results__list__archives";
        linkElement.textContent = file.name.replace(/\.pdf$/, "");

        linkElement.style.animationDelay = `${index * 0.1}s`;

        const iconElement = document.createElement("img");
        iconElement.src = `${window.location.origin}/public/images/layout/web/pdfWeb.png`;
        iconElement.alt = "pdf icon";
        linkElement.appendChild(iconElement);
        listItem.appendChild(linkElement);

        return listItem;
    }

    function updateURL(yearSlug, monthSlug) {
        const url = new URL(window.location);
        if (url.searchParams.get('ano') !== yearSlug || url.searchParams.get('mes') !== monthSlug) {
            url.searchParams.set('ano', yearSlug);
            url.searchParams.set('mes', monthSlug);
            window.history.replaceState({}, '', url);
        }
    }

    yearSelect.addEventListener("change", fetchTransparencies);
    monthSelect.addEventListener("change", fetchTransparencies);
});
